import { useEffect } from 'react';
import { Trans } from 'react-i18next';

import { colors, fonts } from 'components/styles/variables';
import { useFilterContext } from 'contexts/OnboardingFilterContext';
import { filterTruthyKeys } from 'lib/Utilities';
import viewEvent from 'lib/Tracking/Onboarding/ViewEvent';
import useEvents from 'lib/hooks/useEvents';
import { SourcePages } from 'lib/EventSchema';

import { OnboardingComponentProps } from '../Modal';
import Button from '../Button';
import AutolistLogo from '../Logo';
import ToggleButton from '../ToggleButton';

const conditions = [
  {
    label: 'New',
    value: 'new',
  },
  {
    label: 'Used',
    value: 'used',
  },
  {
    label: 'CPO (Certified Pre-Owned)',
    value: 'certified pre-owned',
  },
];

type ConditionType = 'new' | 'used' | 'certified pre-owned';

type Condition = {
  [key in ConditionType]: boolean;
};

const Condition = ({ t, onNextStep }: OnboardingComponentProps): JSX.Element => {
  const logger = useEvents();
  const { filterData, updateFilterData } = useFilterContext();
  const existingConditionValues = filterData.Condition;

  const onSelectCondition = (val: Condition): void => {
    updateFilterData({
      Condition: {
        ...existingConditionValues,
        ...val,
      },
    });
  };

  const onClick = (): void => {
    const selectedConditions = filterTruthyKeys(existingConditionValues);
    onNextStep({ selection: selectedConditions });
  };

  useEffect(() => {
    logger.log(viewEvent({ sourcePage: SourcePages.OnboardingCondition }));
  }, [logger]);

  return (
    <>
      <div className="condition-step-container">
        <div className="condition-content">
          <AutolistLogo />
          <div className="header">
            <Trans i18nKey="onboarding.conditionScreen.header" components={[<br />]} />
          </div>
          <div className="subtitle">{t('onboarding.conditionScreen.subText')}</div>
          <div className="button-container">
            {conditions.map((answer) => (
              <div className="condition-button" key={answer.value}>
                <ToggleButton
                  answer={answer}
                  onClick={(val): void => onSelectCondition(val as Condition)}
                />
              </div>
            ))}
          </div>
        </div>
        <div>
          <Button onClick={onClick}>{t('onboarding.next')}</Button>
        </div>
      </div>

      <style jsx>{`
        .condition-step-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          height: 564px;
          justify-content: space-between;
          width: 295px;
        }
        .condition-content {
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .input-slider-block-container {
          width: 295px;
        }
        .button-container {
          width: 295px;
        }
        .condition-button {
          margin: 24px 0;
        }
        .header {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 700;
          font-size: 22px;
          line-height: 32px;
          letter-spacing: 0.2px;
          margin-bottom: 20px;
        }
        .subtitle {
          text-align: center;
          font-family: ${fonts.default};
          font-weight: 400;
          font-size: 14px;
          line-height: 20px;
          letter-spacing: 0.2px;
          color: ${colors.G3};
        }
      `}</style>
    </>
  );
};

export default Condition;
